import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import InputRange from 'react-input-range';
import { MAX_YEAR, MIN_YEAR } from 'react-scale/pages/api/content/open-dataset';

import styles from './RangeSlider.module.css';

export default function RangeSlider({ onYearUpdate }) {
  const [value, setValue] = useState({ min: MIN_YEAR, max: MAX_YEAR });
  const router = useRouter();

  const handleChange = newValue => {
    setValue(newValue);
    onYearUpdate(newValue);
  };

  useEffect(() => {
    const uri = new URL(window.location.href);
    const min = uri.searchParams.get('minYear');
    const max = uri.searchParams.get('maxYear');

    setValue({
      min: min ?? MIN_YEAR,
      max: max ?? MAX_YEAR
    });
  }, [router.asPath]);

  return (
    <div className="relative text-sm">
      <InputRange
        classNames={{
          track:
            'bg-neutral-300 absolute left-3 right-3 h-2 block rounded-lg cursor-pointer transition-all ease-in-out duration-300',
          activeTrack:
            'bg-gradient-x relative h-2 block rounded-lg cursor-pointer transition-all ease-in-out duration-300',
          inputRange: 'h-2 relative w-full',
          minLabel: 'hidden',
          maxLabel: 'hidden',
          slider: `${styles.slider} bg-white absolute top-0 w-6 h-6 block rounded-full shadow-md appearance-none outline-none cursor-pointer transition-all ease-in-out duration-300`,
          sliderContainer: 'transition-all ease-in-out duration-300',
          valueLabel: `${styles.valueLabel} text-white absolute whitespace-nowrap`,
          labelContainer: `${styles.labelContainer} relative left-[6px] bottom-2`
        }}
        inputRange="inputRange"
        minValue={MIN_YEAR}
        maxValue={MAX_YEAR}
        onChange={handleChange}
        value={value}
      />
    </div>
  );
}
